import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { exerciseTypes } from '../../common/config'
import { loadResult, clearResult, updateResult } from '../../common/results/actions'
import { BackLink, WordboxTest, TranslationTest, OptionsTest, PageHeader, OpenQuestionsTest } from '../components'

class ResultPage extends React.Component {
  state = {
    updatedPoints: {},
  }

  componentDidMount() {
    const { loadResult, match } = this.props
    loadResult(match.params.id)
  }

  componentWillUnmount() {
    this.props.clearResult()
  }

  editPoints = (value, lessonId, itemId) => {
    const newPoints = Object.assign({}, this.state.updatedPoints)

    if (lessonId in newPoints) {
      newPoints[lessonId][itemId] = value
    } else {
      newPoints[lessonId] = { [itemId]: value }
    }

    this.setState({ updatedPoints: newPoints })
  }

  submitPoints = () => {
    const { match, updateResult } = this.props

    updateResult(match.params.id, this.state.updatedPoints)
  }

  render() {
    const { intl, result } = this.props

    if (!result || !result.exercises || !result.exercises.length) {
      return null
    }

    const entity = result.test ? 'test' : 'homework'

    return (
      <div>
        <BackLink />
        <div className="float-left width-full">
          <PageHeader
            title={intl.formatMessage(messages.title)}
          />
          <div className="row result-basic-stats">
            <span>{intl.formatMessage(messages.student)}: {result.student.name}</span>
            <span>{intl.formatMessage(messages[entity])}: {result[entity].name}</span>
            <span>
              {intl.formatMessage(messages.result)}: {result.points}/{result.maxPoints} -
              &nbsp;<b>{Math.round((result.points / result.maxPoints) * 10000) / 100} %</b>
            </span>
          </div>
          {
            result.exercises && result.exercises.map((e, idx) => (
              e.lesson &&
              <div key={e.lesson.id}>
                {
                  e.lesson.type === exerciseTypes.OPEN_QUESTION &&
                  <OpenQuestionsTest
                    showResult
                    lesson={e.lesson}
                    answers={e.answers}
                    points={e.points}
                    editPoints={this.editPoints}
                    saveUpdatedPoints={this.submitPoints}
                    updatedPoints={this.state.updatedPoints}
                    maxPoints={e.maxPoints}
                    intl={intl}
                    lessonOrder={idx + 1}
                  />
                }
                {
                  e.lesson.type === exerciseTypes.WORDBOX &&
                  <WordboxTest
                    showResult
                    lesson={e.lesson}
                    answers={e.answers}
                    points={e.points}
                    maxPoints={e.maxPoints}
                    intl={intl}
                    lessonOrder={idx + 1}
                  />
                }
                {
                  e.lesson.type === exerciseTypes.TRANSLATION &&
                  <TranslationTest
                    showResult
                    lesson={e.lesson}
                    answers={e.answers}
                    points={e.points}
                    maxPoints={e.maxPoints}
                    intl={intl}
                    lessonOrder={idx + 1}
                  />
                }
                {
                  e.lesson.type === exerciseTypes.OPTIONS &&
                  <OptionsTest
                    showResult
                    lesson={e.lesson}
                    answers={e.answers}
                    points={e.points}
                    maxPoints={e.maxPoints}
                    intl={intl}
                    lessonOrder={idx + 1}
                  />
                }
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

ResultPage.defaultProps = {
  result: null,
  match: {},
}

ResultPage.propTypes = {
  loadResult: PropTypes.func.isRequired,
  clearResult: PropTypes.func.isRequired,
  updateResult: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  result: PropTypes.object,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    result: state.results.current,
  }), { loadResult, clearResult, updateResult }),
  injectIntl,
)

export default enhance(ResultPage)

const messages = defineMessages({
  title: {
    id: 'result.page.title',
    defaultMessage: 'Odpovede',
  },
  student: {
    id: 'result.page.student',
    defaultMessage: 'Študent',
  },
  test: {
    id: 'result.page.test',
    defaultMessage: 'Test',
  },
  homework: {
    id: 'result.page.homework',
    defaultMessage: 'Domáca úloha',
  },
  result: {
    id: 'result.page.result',
    defaultMessage: 'Výsledok',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/ResultPage.js